import { useEffect, useState } from "react";
import { getInkedCampaignThumbnailApi } from "../../../../PersonDetail/shared/api";

// Never stored: Inked's answer carries an expiry for when images go private.
const useCampaignThumbnail = (campaignId) => {
  const [thumbnailUrl, setThumbnailUrl] = useState(null);

  useEffect(() => {
    if (!campaignId) return undefined;

    let ignore = false;
    getInkedCampaignThumbnailApi(campaignId).then(({ res }) => {
      if (!ignore) setThumbnailUrl(res?.data?.thumbnail_url || null);
    });

    return () => {
      ignore = true;
    };
  }, [campaignId]);

  return thumbnailUrl;
};

export default useCampaignThumbnail;
